import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { FddUpload } from "@/components/FddUpload";

const F = ({ label, children }) => <div className="space-y-2"><Label className="text-xs uppercase tracking-wider text-slate-400">{label}</Label>{children}</div>;
const NUMS = [["franchise_fee", "Initial franchise fee", "45000"], ["royalty_pct", "Royalty %", "6"], ["marketing_pct", "Marketing fund %", "2"],
  ["investment_min", "Total investment (low)", "350000"], ["investment_max", "Total investment (high)", "900000"], ["system_units", "Units in the system", "1200"]];

export const FranchiseFields = ({ form, set, field, onFdd, onFddClear }) => (
  <div className="space-y-6 rounded-lg border border-emerald-500/20 bg-emerald-500/5 p-5" data-testid="franchise-fields">
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
      <F label="Franchise brand *"><Input data-testid="input-franchise-brand" value={form.franchise_brand} onChange={set("franchise_brand")} className={field} placeholder="e.g. Jersey Mike's Subs" /></F>
      <F label="Category"><Input data-testid="input-franchise-category" value={form.franchise_category} onChange={set("franchise_category")} className={field} placeholder="e.g. Quick-service restaurant" /></F>
    </div>
    <FddUpload fddId={form.fdd_id} onApply={onFdd} onClear={onFddClear} testId="study-fdd" />
    <div>
      <p className="text-xs text-slate-400 mb-3">Optional. Leave any of these blank and the AI estimates them from public knowledge of the brand, flagged for checking against the current FDD.</p>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
        {NUMS.map(([k, label, ph]) => <F key={k} label={label}><Input data-testid={`input-${k.replace(/_/g, "-")}`} type="number" min="0" step="any" value={form[k]} onChange={set(k)} className={`${field} num`} placeholder={`e.g. ${ph}`} /></F>)}
      </div>
    </div>
  </div>
);
